import { shallowRef } from '@vue/composition-api'
import { REGION } from '@ms/config/app'
import { isIOS, isSafari } from 'wap/hybrid/device.js'

const KEY_CLOSED_STATUS = `${REGION}-home-top-download-closed`
const KEY_CLOSED_TIME = `${REGION}-home-top-download-time`

const getDownloadInfo = () => {
  const info = localStorage.getItem('download-info')
  try {
    if (info) {
      return JSON.parse(info)
    }
  } catch (error) {
    console.error(error)
    return null
  }
  return null
}

// 顶部横幅广告 app 下载信息
const downloadInfo = shallowRef(getDownloadInfo())

export const setDownloadInfo = (ads) => {
  if (ads && ads[0]) {
    const { href, image } = ads[0]
    downloadInfo.value = { href, image }
    localStorage.setItem('download-info', JSON.stringify(downloadInfo.value))
  }
}

export const getDownloadSpotId = () => {
  if (isSafari()) {
    const closedTime = parseInt(localStorage.getItem(KEY_CLOSED_TIME))
    const now = Date.now()
    if (closedTime && now > closedTime && now - closedTime < 30 * 86400 * 1000) {
      return ''
    }
  }
  const closedStatus = isIOS() && !!sessionStorage.getItem(KEY_CLOSED_STATUS)
  if (!closedStatus) {
    return 'WapHomeDownloadApp'
  }
}

const closeDownloadInfo = () => {
  downloadInfo.value = null
  if (isSafari()) {
    localStorage.setItem(KEY_CLOSED_TIME, Date.now())
  } else if (isIOS()) {
    sessionStorage.setItem(KEY_CLOSED_STATUS, 1)
  }
}

export default function useDownloadApp() {
  return {
    downloadInfo,
    closeDownloadInfo
  }
}
